/* businesses */
export const GET_LESSONS = "GET_LESSONS"
export const GET_LESSONS_SUCCESS = "GET_LESSONS_SUCCESS"
export const GET_LESSONS_CLEAN = "GET_LESSONS_CLEAN"
export const GET_LESSONS_ERROR = "GET_LESSONS_ERROR"
